import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLanguage } from '@shared/pipes/translate-language.pipe';
import { SharedStore } from '@shared/store/shared.signal-store';
import { AuthStore } from 'app/auth/shared/store/auth.signal-store';
import { DashboardStore } from 'app/dashboard/store/dashboard.signal-store';

@Component({
  selector: 'app-user-profile',
  imports: [
    NgTemplateOutlet,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    TranslateLanguage,
    TranslateModule,
  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserProfileComponent {
  private readonly _store = inject(AuthStore);
  private readonly _sharedStore = inject(SharedStore);
  private readonly _dashboardStore = inject(DashboardStore);

  public readonly user = this._sharedStore.currentUser;

  public readonly accounts = this._sharedStore.accounts;

  public readonly activeAccount = this._sharedStore.activeAccount;

  public readonly is2faEnabled = this._sharedStore.is2FAEnabled;

  public readonly isSsoOnly = this._sharedStore.isSsoOnly;

  public readonly language = this._sharedStore.currentLanguage;

  public readonly menuTrigger = viewChild.required('menuTrigger', {
    read: MatMenuTrigger,
  });

  public closeMenu() {
    this.menuTrigger().closeMenu();
  }

  public logout() {
    this.closeMenu();
    this._store.logout();
  }

  public changePassword() {
    this.closeMenu();
    this._store.openChangePasswordDialog();
  }

  public update2FA() {
    this.closeMenu();
    this._store.openEnableTwoFactorAuthDialog(false);
  }

  public changeLanguage() {
    this.closeMenu();
    this._sharedStore.openLanguageDialog();
  }

  public openAPIKeyDialog() {
    this.closeMenu();
    this._store.openApiKeyDialog();
  }

  public openCustomSettingsDialog() {
    this.closeMenu();
    this._dashboardStore.openCustomSettingsDialog();
  }
}
